import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.ZONE_CREATE_SUCCESS, data: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.ZONE_CREATE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status == 201) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const zoneCreate = (data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.ZONE_CREATE_REQUEST });

    axios.post('/zones', data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
